// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Uk-Q","right":"styles_right__31EB_"};